// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__YkdKc","unstyled":"link_unstyled___PY_X","inline":"link_inline__L5Wfg","asDiv":"link_asDiv__nDMMR"};